import React, { useState, useRef, useEffect } from 'react';
import ColorPicker from "../store/ColorPicker";
import LivePreview from '../components/LivePreview';
import { updateAppUiPreferences, updateMailData } from '../services/customerApi';
import {Container, Row, Card, Button} from "react-bootstrap";
import Select from 'react-select'
//import { useAuth0 } from "@auth0/auth0-react"; uncomment if u need to include user.name and user.email to form fields by default
import {languages} from "../config";

import EmailEditor from 'avalanche-email-editor';

function Customize() {
	//const { user } = useAuth0(); uncomment if u need to include user.name and user.email to form fields by default

	/*From data*/
	const [formData, setFormData] = useState(
		localStorage.getItem('uiPreferences') !== "undefined" ? JSON.parse(localStorage.getItem('uiPreferences')) : {
			bgColor: "#ffffff",
			textColor: "#000000",
			heading: "Earn 10.000 Satoshis",
			textMessage: "{{name}} is inviting you with code {{referral_code}}, click link {{link}} to claim the reward"
		});
	const [showColorBackground, setShowColorBackground] = useState(true);

	const onColorPickerInfoChangeBackground = (color) => {
		setFormData(v => ({
			...v,
			bgColor: color.hex
		}))
		localStorage.setItem('uiPreferences', JSON.stringify(formData))
	};
	const onColorPickerInfoChangeText = (color) => {
		setFormData(v => ({
			...v,
			textColor: color.hex
		}))
		localStorage.setItem('uiPreferences', JSON.stringify(formData))
	};


	const setFormDataPicture = (e) => {
		setFormData(v => ({
			...v,
			bgColor: e.target.value
		}))
		localStorage.setItem('uiPreferences', JSON.stringify(formData))
	};
	const setFormDataHeding = (e) => {
		setFormData(v => ({
			...v,
			heading: e.target.value
		}))
		localStorage.setItem('uiPreferences', JSON.stringify(formData))
	};
	const setFormDataTextMessage = (e) => {
		setFormData(v => ({
			...v,
			textMessage: e.target.value
		}))
		localStorage.setItem('uiPreferences', JSON.stringify(formData))
	};
	const selectionChange = (e) => {
		if(Number(e.target.value) === 1){
			setShowColorBackground(true)
		} else {
			setShowColorBackground(false)
		}
	};


	const handleUpdateUi = (async () => {
		localStorage.setItem('uiPreferences', JSON.stringify(formData))
		await updateAppUiPreferences({
			data: formData,
			userId: localStorage.getItem('userId'),
		});
		alert('Saved!')
	});

	const styles = {
		title: "Color Picker",
		labelStyle: {
			paddingBottom: "7px",
			fontSize: "11px"
		},
		colorTextBoxStyle: {
			height: "35px",
			border: "none",
			borderBottom: "1px solid lightgray",
			paddingLeft: "35px"
		}
	};

	/*Mail form data*/
	const defaultDesign = {"counters":{"u_column":8,"u_row":8,"u_content_text":6,"u_content_html":2,"u_content_image":1},"body":{"rows":[{"cells":[1],"columns":[{"contents":[{"type":"text","values":{"containerPadding":"10px","color":"#000000","textAlign":"left","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"hideDesktop":false,"_meta":{"htmlID":"u_content_text_1","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"text":"<p style=\"font-size: 14px; line-height: 140%; text-align: center;\"><span style=\"font-size: 24px; line-height: 33.6px;\"><strong><span style=\"line-height: 33.6px; font-size: 24px;\">Game On</span></strong></span></p>"}}],"values":{"backgroundColor":"","padding":"0px","border":{},"_meta":{"htmlID":"u_column_1","htmlClassNames":"u_column"}}}],"values":{"displayCondition":null,"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"padding":"0px","hideDesktop":false,"_meta":{"htmlID":"u_row_1","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true}},{"cells":[1],"columns":[{"contents":[{"type":"image","values":{"containerPadding":"10px","src":{"url":"https://unroll-images-production.s3.amazonaws.com/projects/0/1618523518690-image-7.png","width":378,"height":378},"textAlign":"center","altText":"Image","action":{"name":"web","values":{"href":"","target":"_blank"}},"_meta":{"htmlID":"u_content_image_1","htmlClassNames":"u_content_image"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true}}],"values":{"backgroundColor":"","padding":"0px","border":{},"_meta":{"htmlID":"u_column_7","htmlClassNames":"u_column"}}}],"values":{"displayCondition":null,"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"padding":"0px","_meta":{"htmlID":"u_row_7","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true}},{"cells":[1],"columns":[{"contents":[{"type":"text","values":{"containerPadding":"10px","color":"#000000","textAlign":"left","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"_meta":{"htmlID":"u_content_text_6","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"text":"<p style=\"font-size: 14px; line-height: 140%;\"><strong><span style=\"font-size: 20px; line-height: 28px;\">Hi, it's about time you discover Hype and Vice. Use my link for 10% off your first order!</span></strong></p>"}}],"values":{"backgroundColor":"","padding":"0px","border":{},"_meta":{"htmlID":"u_column_8","htmlClassNames":"u_column"}}}],"values":{"displayCondition":null,"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"padding":"0px","_meta":{"htmlID":"u_row_8","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true}},{"cells":[1],"columns":[{"contents":[{"type":"html","values":{"html":"<div style=\"text-align:center\"><a href=\"{{link}}\" target=\"_blank\">{{link}}</a></div>","containerPadding":"10px","_meta":{"htmlID":"u_content_html_2","htmlClassNames":"u_content_html"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true}}],"values":{"backgroundColor":"","padding":"0px","border":{},"_meta":{"htmlID":"u_column_4","htmlClassNames":"u_column"}}}],"values":{"displayCondition":null,"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"padding":"0px","hideDesktop":false,"_meta":{"htmlID":"u_row_4","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true}},{"cells":[1],"columns":[{"contents":[{"type":"text","values":{"containerPadding":"10px","color":"#000000","textAlign":"left","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"hideDesktop":false,"_meta":{"htmlID":"u_content_text_4","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"text":"<p style=\"font-size: 14px; line-height: 140%; text-align: center;\"><span style=\"font-size: 28px; line-height: 39.2px;\"><strong><span style=\"line-height: 39.2px; font-size: 28px;\">Introduction</span></strong></span></p>\n<p style=\"font-size: 14px; line-height: 140%; text-align: center;\"><span style=\"font-size: 20px; line-height: 28px;\">#Changing the game</span></p>"}}],"values":{"backgroundColor":"#d3d3d3","padding":"0px","border":{},"_meta":{"htmlID":"u_column_5","htmlClassNames":"u_column"}}}],"values":{"displayCondition":null,"columns":false,"backgroundColor":"#d3d3d3","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"padding":"0px","hideDesktop":false,"_meta":{"htmlID":"u_row_5","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true}},{"cells":[1],"columns":[{"contents":[{"type":"text","values":{"containerPadding":"10px","color":"#000000","textAlign":"left","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"hideDesktop":false,"_meta":{"htmlID":"u_content_text_5","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"text":"<p style=\"font-size: 14px; line-height: 140%; text-align: center;\"><span style=\"font-size: 32px; line-height: 44.8px;\">#Hype and Vice is a new approach to college apparel.</span></p>"}}],"values":{"backgroundColor":"","padding":"0px","border":{},"_meta":{"htmlID":"u_column_6","htmlClassNames":"u_column"}}}],"values":{"displayCondition":null,"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"padding":"0px","hideDesktop":false,"_meta":{"htmlID":"u_row_6","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true}}],"values":{"backgroundColor":"#e7e7e7","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"contentWidth":"500px","contentAlign":"center","fontFamily":{"label":"Arial","value":"arial,helvetica,sans-serif"},"preheaderText":"","linkStyle":{"body":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"_meta":{"htmlID":"u_body","htmlClassNames":"u_body"}}},"schemaVersion":5}
	const [formDataMail, setFormDataMail] = useState(
		localStorage.getItem('dataMail') !== "undefined" && localStorage.getItem('dataMail') !== null  ? JSON.parse(localStorage.getItem('dataMail')) : {
			userMail: 'avalanchereferrals@gmail.com', //user.email,
			fromName: 'Referral Account', //user.name,
			mailSubject: "Hello ✔",
			languages: null,
			htmlContent: "<b>Click the <a href='{{link}}'>{{link}}</a></b>",
			designContent: defaultDesign,
			languagesReward: null,
			htmlContentReward: "You earn a reward! <b>Click the <a href='{{link}}'>{{link}}</a></b> ",
			designContentReward: defaultDesign
		});
	const [languageTemplater, setLanguageTemplater] = useState(formDataMail.languages ? Array.isArray(formDataMail.languages) ? formDataMail.languages.length > 0 ? true : false : false : false);

	const [fieldsSetupVisible, setFieldsSetupVisible] = useState(true);
	useEffect(() => {
		if(formDataMail && formDataMail.userMail && formDataMail.userMail === "avalanchereferrals@gmail.com"){
			setFieldsSetupVisible(false);
		} else {
			setFieldsSetupVisible(true)
		}
	},[formDataMail]);

	const linkDefinition = '{{link}}';
	const referralDefinition = '{{referral_code}}'

	const setFormDataMailEmail = (e) => {
		setFormDataMail(v => ({
			...v,
			userMail: e.target.value
		}))
		localStorage.setItem('dataMail', JSON.stringify(formDataMail))
	};

	const setFormDataMailFromName = (e) => {
		setFormDataMail(v => ({
			...v,
			fromName: e.target.value
		}))
		localStorage.setItem('dataMail', JSON.stringify(formDataMail))
	};

	const setFormDataMailSubject = (e) => {
		setFormDataMail(v => ({
			...v,
			mailSubject: e.target.value
		}))
		localStorage.setItem('dataMail', JSON.stringify(formDataMail))
	};

	const setVisibleBlocksDataMail = (e) => {
		if(e.target.checked){
			localStorage.setItem('restoreDataMail', JSON.stringify(formDataMail))
			setFormDataMail(v => ({
				...v,
				userMail: 'avalanchereferrals@gmail.com',
			}))
			setFieldsSetupVisible(false)
		} else {
			const restoreDataMail = JSON.parse(localStorage.getItem('restoreDataMail'))
			if(restoreDataMail){
				setFormDataMail(v => ({
					...v,
					userMail: restoreDataMail.userMail,
				}))
			}
			setFieldsSetupVisible(true)
		}
	};

	//Invite email template
	const emailEditorRef = useRef([null]);
	const [templateHtmlData, setTemplateHtmlData] = useState([])
	const [templateDesignData, setTemplateDesignData] = useState([])
	const [inviteTemplates, setInviteTemplates] = useState({
		items: (formDataMail.languages && Array.isArray(formDataMail.languages) && formDataMail.languages.length > 0) ? formDataMail.languages : [0]
	})

	useEffect(() => {
		emailEditorRef.current = emailEditorRef.current.slice(0, inviteTemplates.items.length);
		console.log('emailEditorRef', emailEditorRef)
	}, [inviteTemplates.items]);


	const loadEditorEmail = (index) => {
		const isStoredDesign = localStorage.getItem('dataMailDesign') && localStorage.getItem('dataMailDesign') !== 'null' && localStorage.getItem('dataMailDesign') !== 'undefined'
		const lastDesign = isStoredDesign ? JSON.parse(localStorage.getItem('dataMailDesign')) : defaultDesign
		let loadLastDesign = lastDesign

		if(!lastDesign){
			loadLastDesign = defaultDesign
		} else {
			if(Array.isArray(loadLastDesign)){
				if(loadLastDesign.length > 1){
					if(lastDesign[index] === "null" || lastDesign[index] == null){
						lastDesign[index] = defaultDesign
					}
					loadLastDesign = lastDesign[index]
				} else {
					if(lastDesign[0] === "null" || lastDesign[0] == null){
						lastDesign[0] = defaultDesign
					}
					loadLastDesign = lastDesign[0]
				}
			} else {
				loadLastDesign = lastDesign
			}
		}

		if(emailEditorRef && emailEditorRef.current && emailEditorRef.current[index] && emailEditorRef.current[index].editor){
			const currentForm = formDataMail
			setFormDataMail(currentForm)
			emailEditorRef.current[index].editor.loadDesign(loadLastDesign)
			emailEditorRef.current[index].editor.addEventListener('design:updated', (data) => {
				for(let i = 0; i < emailEditorRef.current.length; i++){
					emailEditorRef.current[i].editor.exportHtml((data) => {
						const { design, html } = data;
						let storeTemplateHtmlData = templateHtmlData
						storeTemplateHtmlData[i] = html

						setTemplateHtmlData(storeTemplateHtmlData)

						let storeTemplateDesignData = templateDesignData
						storeTemplateDesignData[i] = design

						setTemplateDesignData(storeTemplateDesignData)

						let forSaveFormData = formDataMail
						forSaveFormData.htmlContent = storeTemplateHtmlData.length > 1 ? storeTemplateHtmlData : storeTemplateHtmlData[0]
						forSaveFormData.designContent = storeTemplateDesignData.length > 1 ? storeTemplateDesignData : storeTemplateDesignData[0]

						setFormDataMail(forSaveFormData)

						localStorage.setItem('dataMail', JSON.stringify(forSaveFormData))
						localStorage.setItem('dataMailDesign', JSON.stringify(storeTemplateDesignData))
					});
				}
			});
		} else {
			//window.location.reload();
		}
	}


	//Add and remove templates
	const handleLanguageTemplater = (e) => {
		if(e.target.checked){
			setLanguageTemplater(true)

			if(!formDataMail.length){
				setFormDataMail(v => ({
					...v,
					languages: []
				}))
			}
			if(formDataMail && formDataMail.languages && formDataMail.languages.length < 1){
				setFormDataMail(v => ({
					...v,
					languages: []
				}))
			}

			localStorage.setItem('dataMail', JSON.stringify(formDataMail))
		} else {
			setLanguageTemplater(false)
			setFormDataMail(v => ({
				...v,
				languages: null
			}))
			setInviteTemplates({
				items: [0]
			})
			localStorage.setItem('dataMail', JSON.stringify(formDataMail))
		}
	};

	const handleAddLangTemplate = () => {
		let curItems = [...inviteTemplates.items, inviteTemplates.items.length]
		let currentLanguages = formDataMail.languages && Array.isArray(formDataMail.languages) ? [...formDataMail.languages, formDataMail.languages.length] : [0]
		curItems = {
			items: curItems
		}
		setFormDataMail(v => ({
			...v,
			languages: currentLanguages
		}))
		setInviteTemplates(curItems);
		localStorage.setItem('dataMail', JSON.stringify(formDataMail))
	};

	const handleRemoveLangTemplate = index => {
		let curItems = inviteTemplates.items
		curItems.splice(index, 1)
		curItems = {
			items: curItems
		}
		setInviteTemplates(curItems);

		let curLangs = formDataMail.languages
		curLangs.splice(index, 1)
		setFormDataMail(v => ({
			...v,
			languages: curLangs
		}))
		localStorage.setItem('dataMail', JSON.stringify(formDataMail))
	};

	const handleLangSelectChange = (e, i) => {
		let langField = formDataMail.languages
		if (langField && Array.isArray(formDataMail.languages) && !langField.includes(e.value)) {
			if(langField[i]){
				langField[i] = e.value
			} else {
				langField.push(e.value)
			}
			setFormDataMail(v => ({
				...v,
				languages: langField
			}))
			localStorage.setItem('dataMail', JSON.stringify(formDataMail))
		} else {
			setFormDataMail(v => ({
				...v,
				languages: [e.value]
			}))
			localStorage.setItem('dataMail', JSON.stringify(formDataMail))
		}
	}

	let options = []
	for(let i = 0; i < languages.length; i++){
		options.push({
			value: i,
			label: languages[i].name
		})
	}

	const LangChooseList = () => {
		if(formDataMail.languages && formDataMail.languages.length > 1){
			return (
				<>
					<div className="domensList">
						{formDataMail && formDataMail.languages && Array.isArray(formDataMail.languages) && formDataMail.languages.map((x, i) => {
							return (
								<div className="form-field mailDataCheckbox" key={i ? i + 15 : 0}>
									<div className="field-title">
										Select language
									</div>
									<div className="colorPicker">
										<Select
											options={options}
											value={formDataMail.languages && formDataMail.languages[i ? i : 0] ? {
												value: formDataMail.languages[i ? i : 0],
												label: languages[formDataMail.languages[i ? i : 0]].name
											} : false}
											key={i + 16}
											onChange={(e) => handleLangSelectChange(e, i ? i : 0)} />
									</div>
									<div className="addAndRemove input-group-append" key={i + 17}>
										{inviteTemplates.items.length !== 1 && <div key={i + 18} className="removeDomen btn btn-danger redButton" onClick={() => handleRemoveLangTemplate(i ? i : 0)}>Remove template</div>}
									</div>
								</div>
							)
						})}
					</div>
					<div style={{textAlign: "center", marginTop: "20px"}}>
						<Button className="addDomen" variant="primary" onClick={handleAddLangTemplate}>Add one more template</Button>
					</div>
				</>
			)
		} else {
			return (
				<>
					<div className="domensList">
						{inviteTemplates && inviteTemplates.items.map((x, i) => {
							return (
								<div className="form-field mailDataCheckbox" key={i ? i + 19 : 0}>
									<div className="field-title" key={i + 20}>
										Select language
									</div>
									<div className="colorPicker" key={i + 21}>
										<Select
											options={options}
											value={formDataMail.languages && formDataMail.languages[i ? i : 0] ? {
												value: formDataMail.languages[i ? i : 0],
												label: languages[formDataMail.languages[i ? i : 0]].name
											} : false}
											key={i + 22}
											onChange={(e) => handleLangSelectChange(e, i ? i : 0)} />
									</div>
									<div className="addAndRemove input-group-append" key={i + 23}>
										{inviteTemplates.items.length !== 1 && <div key={i + 24} className="removeDomen btn btn-danger redButton" onClick={() => handleRemoveLangTemplate(i ? i : 0)}>Remove template</div>}
									</div>
								</div>
							)
						})}
					</div>
					<div style={{textAlign: "center", marginTop: "20px"}}>
						<Button className="addDomen" variant="primary" onClick={handleAddLangTemplate}>Add one more template</Button>
					</div>
				</>
			)
		}
	};

	console.log(formDataMail)

	/* Mail settings for thank you (reward) email */

	const [languageRewardTemplater, setLanguageRewardTemplater] = useState(formDataMail.languagesReward ? Array.isArray(formDataMail.languagesReward) ? formDataMail.languagesReward.length > 0 ? true : false : false : false);
	//Reward email template
	const emailEditorRewardRef = useRef([null]);
	const [templateRewardHtmlData, setTemplateRewardHtmlData] = useState([])
	const [templateRewardDesignData, setTemplateRewardDesignData] = useState([])
	const [rewardTemplates, setRewardTemplates] = useState({
		items: (formDataMail.languagesReward && Array.isArray(formDataMail.languagesReward) && formDataMail.languagesReward.length > 0) ? formDataMail.languagesReward : [0]
	})

	useEffect(() => {
		emailEditorRewardRef.current = emailEditorRewardRef.current.slice(0, rewardTemplates.items.length);
		console.log('emailEditorRewardRef', emailEditorRewardRef)
	}, [rewardTemplates.items]);


	const loadEditorRewardEmail = (index) => {
		const isStoredDesign = localStorage.getItem('dataMailRewardDesign') && localStorage.getItem('dataMailRewardDesign') !== 'null' && localStorage.getItem('dataMailRewardDesign') !== 'undefined'
		const lastDesign = isStoredDesign ? JSON.parse(localStorage.getItem('dataMailRewardDesign')) : defaultDesign
		let loadLastDesign = lastDesign

		if(!lastDesign){
			loadLastDesign = defaultDesign
		} else {
			if(Array.isArray(loadLastDesign)){
				if(loadLastDesign.length > 1){
					if(lastDesign[index] === "null" || lastDesign[index] == null){
						lastDesign[index] = defaultDesign
					}
					loadLastDesign = lastDesign[index]
				} else {
					if(lastDesign[0] === "null" || lastDesign[0] == null){
						lastDesign[0] = defaultDesign
					}
					loadLastDesign = lastDesign[0]
				}
			} else {
				loadLastDesign = lastDesign
			}
		}

		if(emailEditorRewardRef && emailEditorRewardRef.current && emailEditorRewardRef.current[index] && emailEditorRewardRef.current[index].editor){
			emailEditorRewardRef.current[index].editor.loadDesign(loadLastDesign)
			emailEditorRewardRef.current[index].editor.addEventListener('design:updated', (data) => {
				const currentForm = formDataMail
				setFormDataMail(currentForm)
				for(let i = 0; i < emailEditorRewardRef.current.length; i++){
					emailEditorRewardRef.current[i].editor.exportHtml((data) => {
						const { design, html } = data;
						let storeTemplateHtmlData = templateRewardHtmlData
						storeTemplateHtmlData[i] = html

						setTemplateRewardHtmlData(storeTemplateHtmlData)

						let storeTemplateDesignData = templateRewardDesignData
						storeTemplateDesignData[i] = design

						setTemplateRewardDesignData(storeTemplateDesignData)

						let forSaveFormData = formDataMail
						forSaveFormData.htmlContentReward = storeTemplateHtmlData.length > 1 ? storeTemplateHtmlData : storeTemplateHtmlData[0]
						forSaveFormData.designContentReward = storeTemplateDesignData.length > 1 ? storeTemplateDesignData : storeTemplateDesignData[0]

						setFormDataMail(forSaveFormData)

						localStorage.setItem('dataMail', JSON.stringify(forSaveFormData))
						localStorage.setItem('dataMailRewardDesign', JSON.stringify(storeTemplateDesignData))
					});
				}
			});
		} else {
			//window.location.reload();
		}
	}


	//Add and remove templates
	const handleRewardLanguageTemplater = (e) => {
		if(e.target.checked){
			setLanguageRewardTemplater(true)

			if(!formDataMail.length){
				setFormDataMail(v => ({
					...v,
					languagesReward: []
				}))
			}

			if(formDataMail && formDataMail.languagesReward && formDataMail.languagesReward.length < 1) {
				setFormDataMail(v => ({
					...v,
					languagesReward: []
				}))
			}

			localStorage.setItem('dataMail', JSON.stringify(formDataMail))
		} else {
			setLanguageRewardTemplater(false)
			setFormDataMail(v => ({
				...v,
				languagesReward: null
			}))
			setRewardTemplates({
				items: [0]
			})
			localStorage.setItem('dataMail', JSON.stringify(formDataMail))
		}
	};

	const handleAddRewardLangTemplate = () => {
		let curItems = [...rewardTemplates.items, rewardTemplates.items.length]
		let currentLanguages = formDataMail.languagesReward && Array.isArray(formDataMail.languagesReward) ? [...formDataMail.languagesReward, formDataMail.languagesReward.length] : [0]
		curItems = {
			items: curItems
		}
		setFormDataMail(v => ({
			...v,
			languagesReward: currentLanguages
		}))
		setRewardTemplates(curItems);
		localStorage.setItem('dataMail', JSON.stringify(formDataMail))
	};

	const handleRemoveRewardLangTemplate = index => {
		let curItems = [...rewardTemplates.items]
		curItems.splice(index, 1)
		curItems = {
			items: curItems
		}
		setRewardTemplates(curItems);

		let curLangs = formDataMail.languagesReward
		curLangs.splice(index, 1)
		setFormDataMail(v => ({
			...v,
			languagesReward: curLangs
		}))
		localStorage.setItem('dataMail', JSON.stringify(formDataMail))
	};

	const handleRewardLangSelectChange = (e, i) => {
		let langField = formDataMail.languagesReward
		if (langField && Array.isArray(formDataMail.languagesReward) && !langField.includes(e.value)) {
			if(langField[i]){
				langField[i] = e.value
			} else {
				langField.push(e.value)
			}
			setFormDataMail(v => ({
				...v,
				languagesReward: langField
			}))
			localStorage.setItem('dataMail', JSON.stringify(formDataMail))
		} else {
			setFormDataMail(v => ({
				...v,
				languagesReward: [e.value]
			}))
			localStorage.setItem('dataMail', JSON.stringify(formDataMail))
		}
	}

	const RewardLangChooseList = () => {
		if(formDataMail.languagesReward && formDataMail.languagesReward.length > 1){
			return (
				<>
					<div className="domensList">
						{formDataMail && formDataMail.languagesReward && Array.isArray(formDataMail.languagesReward) && formDataMail.languagesReward.map((x, i) => {
							return (
								<div className="form-field mailDataCheckbox" key={i ? i + 1 : 0}>
									<div className="field-title">
										Select language
									</div>
									<div className="colorPicker">
										<Select
											options={options}
											value={formDataMail.languagesReward && formDataMail.languagesReward[i ? i : 0] ? {
												value: formDataMail.languagesReward[i ? i : 0],
												label: languages[formDataMail.languagesReward[i ? i : 0]].name
											} : false}
											key={i + 2}
											onChange={(e) => handleRewardLangSelectChange(e, i ? i : 0)} />
									</div>
									<div className="addAndRemove input-group-append" key={i + 3}>
										{rewardTemplates.items.length !== 1 && <div key={i + 4} className="removeDomen btn btn-danger redButton" onClick={() => handleRemoveRewardLangTemplate(i ? i : 0)}>Remove template</div>}
									</div>
								</div>
							)
						})}
					</div>
					<div style={{textAlign: "center", marginTop: "20px"}}>
						<Button className="addDomen" variant="primary" onClick={handleAddRewardLangTemplate}>Add one more template</Button>
					</div>
				</>
			)
		} else {
			return (
				<>
					<div className="domensList">
						{rewardTemplates && rewardTemplates.items.map((x, i) => {
							return (
								<div className="form-field mailDataCheckbox" key={i ? i + 5 : 0}>
									<div className="field-title" key={i + 6}>
										Select language
									</div>
									<div className="colorPicker" key={i + 7}>
										<Select
											options={options}
											value={formDataMail.languagesReward && formDataMail.languagesReward[i ? i : 0] ? {
												value: formDataMail.languagesReward[i ? i : 0],
												label: languages[formDataMail.languagesReward[i ? i : 0]].name
											} : false}
											key={i + 8}
											onChange={(e) => handleRewardLangSelectChange(e, i ? i : 0)} />
									</div>
									<div className="addAndRemove input-group-append" key={i + 9}>
										{rewardTemplates.items.length !== 1 && <div key={i + 10} className="removeDomen btn btn-danger redButton" onClick={() => handleRemoveRewardLangTemplate(i ? i : 0)}>Remove template</div>}
									</div>
								</div>
							)
						})}
					</div>
					<div style={{textAlign: "center", marginTop: "20px"}}>
						<Button className="addDomen" variant="primary" onClick={handleAddRewardLangTemplate}>Add one more template</Button>
					</div>
				</>
			)
		}
	};


	/* End of reward mail settings */

	//Save all settings
	const handleUpdateEmail = (async () => {
		const currentForm = formDataMail
		setFormDataMail(currentForm)

		for(let i = 0; i < emailEditorRef.current.length; i++){
			emailEditorRef.current[i].editor.exportHtml((data) => {
				const { design, html } = data;
				let storeTemplateHtmlData = templateHtmlData
				storeTemplateHtmlData[i] = html

				setTemplateHtmlData(storeTemplateHtmlData)

				let storeTemplateDesignData = templateDesignData
				storeTemplateDesignData[i] = design

				setTemplateDesignData(storeTemplateDesignData)

				let forSaveFormData = formDataMail
				forSaveFormData.htmlContent = storeTemplateHtmlData.length > 1 ? storeTemplateHtmlData : storeTemplateHtmlData[0]
				forSaveFormData.designContent = storeTemplateDesignData.length > 1 ? storeTemplateDesignData : storeTemplateDesignData[0]

				setFormDataMail(forSaveFormData)

				localStorage.setItem('dataMail', JSON.stringify(forSaveFormData))
				localStorage.setItem('dataMailDesign', JSON.stringify(storeTemplateDesignData))
			});
		}

		for(let b = 0; b < emailEditorRewardRef.current.length; b++){
			emailEditorRewardRef.current[b].editor.exportHtml((data) => {
				const { design, html } = data;
				let storeTemplateHtmlData = templateRewardHtmlData
				storeTemplateHtmlData[b] = html

				setTemplateRewardHtmlData(storeTemplateHtmlData)

				let storeTemplateDesignData = templateRewardDesignData
				storeTemplateDesignData[b] = design

				setTemplateRewardDesignData(storeTemplateDesignData)

				let forSaveFormData = formDataMail
				forSaveFormData.htmlContentReward = storeTemplateHtmlData.length > 1 ? storeTemplateHtmlData : storeTemplateHtmlData[0]
				forSaveFormData.designContentReward = storeTemplateDesignData.length > 1 ? storeTemplateDesignData : storeTemplateDesignData[0]

				setFormDataMail(forSaveFormData)

				localStorage.setItem('dataMail', JSON.stringify(forSaveFormData))
				localStorage.setItem('dataMailRewardDesign', JSON.stringify(storeTemplateDesignData))
			});
		}
		//localStorage.setItem('dataMail', JSON.stringify(formDataMail))
		console.log(formDataMail)
		const finalFormToSave = JSON.parse(localStorage.getItem('dataMail'))

		await updateMailData({
			data: finalFormToSave,
			userId: localStorage.getItem('userId'),
		});

		if(formDataMail.userMail !== "avalanchereferrals@gmail.com") {
			alert(`Saved! You receive a confirmation email on your ${formDataMail.userMail}`)
		} else {
			alert("Saved!")
		}

	});




	return (
		<>
			<div className="customize_page p-4">
				<Container>
					<Row>
						<Card className="col-md-12 p-4 border-0">
							<div className="settingForm">

								<div className="form-field">
									<div className="field-title">
										Background:
									</div>
									<div className="field-selection">
										<select name="giveChoise" onChange={selectionChange} >
											<option value="0">Choose type</option>
											<option value="1">Color</option>
											<option value="2">Picture</option>
										</select>
									</div>
									{showColorBackground && (
										<div className="colorPicker">
											<ColorPicker
												onColorChange={onColorPickerInfoChangeBackground}
												title={styles.title}
												labelStyle={styles.labelStyle}
												colorTextBoxStyle={styles.colorTextBoxStyle}
												pickerType={"Chrome"}
												color={formData.bgColor}
											/>
										</div>
									)}
									{!showColorBackground && (
										<input type="text" name="backgroundPicture" placeholder="https://yoursite.url/path/to/image.jpg" value={formData.bgColor || ''} onChange={setFormDataPicture} />
									)}
								</div>
								<div className="form-field">
									<div className="field-title">
										Text color:
									</div>
									<div className="colorPicker">
										<ColorPicker
											onColorChange={onColorPickerInfoChangeText}
											title={styles.title}
											labelStyle={styles.labelStyle}
											colorTextBoxStyle={styles.colorTextBoxStyle}
											pickerType={"Chrome"}
											color={formData.textColor}
										/>
									</div>
								</div>
								<div className="form-field">
									<div className="field-title">
										Text color:
									</div>
									<div className="colorPicker">
										<input type="text" name="heading" value={formData.heading || ''} onChange={setFormDataHeding} />
									</div>
								</div>
								<div className="form-field">
									<div className="field-title">
										Text message:
									</div>
									<div className="colorPicker">
										<input type="text" name="textMessage" value={formData.textMessage || ''} onChange={setFormDataTextMessage} />
									</div>
								</div>
							</div>
							<button className="ant-btn ant-btn-primary settingsButton" onClick={handleUpdateUi}>
								Save
							</button>

							<div className="previewText">
								Previews
							</div>

							<LivePreview data={formData} />

							<div className="settingForm">
								<hr style={{marginTop: "50px"}}></hr>
								<h3 className="previewText">In this section you can setup your email message and give access to your email account, so we can use smtp method</h3>
								<div className="attentionMailBlock">
									<ul>
										<li>
											<span className="redAlert">{linkDefinition}</span> - this is the place where the link will be attached automatically generated by our service
										</li>
										<li>
											<span className="redAlert">{referralDefinition}</span> - this is the place where the referral code will be attached automatically generated by our service
										</li>
									</ul>
								</div>

								{fieldsSetupVisible && (
									<div className="form-field">
										<div className="field-title">
											Email:
										</div>
										<div className="colorPicker">
											<input type="text" name="userMail" placeholder="your@email.com" value={formDataMail.userMail || ''} onChange={setFormDataMailEmail} />
										</div>
									</div>
								)}
								<div className="form-field">
									<div className="field-title">
										From name:
									</div>
									<div className="colorPicker">
										<input type="text" name="fromName" placeholder="mycompany.com" value={formDataMail.fromName || ''} onChange={setFormDataMailFromName} />
									</div>
								</div>

								<div className="form-field mailDataCheckbox">
									<div className="field-title">
										Use Avalanche Email service:
									</div>
									<div className="colorPicker">
										<input type="checkbox" name="useAvalancheEmail" value="1" defaultChecked={fieldsSetupVisible === false ? false : true}  onChange={setVisibleBlocksDataMail} />
									</div>
								</div>
								<div className="form-field">
									<div className="field-title">
										Subject:
									</div>
									<div className="colorPicker">
										<input type="text" name="mailSubject" placeholder="123456789" value={formDataMail.mailSubject || ''} onChange={setFormDataMailSubject} />
									</div>
								</div>

								<div className="form-field mailDataCheckbox">
									<div className="field-title">
										Use language templates
									</div>
									<div className="colorPicker">
										<input type="checkbox" name="useAvalancheEmail" value="1"
											   defaultChecked={languageTemplater === false ? false : true}
											   onChange={handleLanguageTemplater}/>
									</div>
								</div>
								{(languageTemplater  || (formDataMail.languages && Array.isArray(formDataMail.languages))) && (
									<LangChooseList />
								)}

								<div className="form-field emailEditor">
									<div className="field-title">
										Email body content:
									</div>
									<div className="colorPicker htmlContent">
										{inviteTemplates.items.map((item, i) => (
											<div key={i + 11}>
												{(formDataMail.languages && Array.isArray(formDataMail.languages) && formDataMail.languages[i])  && (
													<p className="template-language">
														Group ID: <span className="redAlert">{i}</span>.
														For language: <span className="redAlert">{languages[formDataMail.languages[i ? i : 0]].name}</span>
													</p>
												)}
												<EmailEditor
													key={i + 12}
													ref={el => emailEditorRef.current[i] = el}
													onLoad={() => loadEditorEmail(i)}
												/>
											</div>
										))}
									</div>
								</div>
								<hr></hr>
								<div className="form-field mailDataCheckbox">
									<p style={{fontSize: '18px'}}><strong>Reward letter</strong></p>
								</div>

								<div className="form-field mailDataCheckbox">
									<div className="field-title">
										Use language templates
									</div>
									<div className="colorPicker">
										<input type="checkbox" name="useAvalanchRewardLangeEmail" value="1"
											   defaultChecked={languageRewardTemplater === false ? false : true}
											   onChange={handleRewardLanguageTemplater}/>
									</div>
								</div>
								{(languageRewardTemplater) && (
									<RewardLangChooseList />
								)}

								<div className="form-field emailEditor">
									<div className="field-title">
										Email body content:
									</div>
									<div className="colorPicker htmlContent">
										{rewardTemplates.items.map((item, i) => (
											<div key={i + 13}>
												{(formDataMail.languagesReward && Array.isArray(formDataMail.languagesReward) && formDataMail.languagesReward[i])  && (
													<p className="template-language">
														Group ID: <span className="redAlert">{i}</span>.
														For language: <span className="redAlert">{languages[formDataMail.languagesReward[i ? i : 0]].name}</span>
													</p>
												)}
												<EmailEditor
													key={i + 14}
													ref={el => emailEditorRewardRef.current[i] = el}
													onLoad={() => loadEditorRewardEmail(i)}
												/>
											</div>
										))}
									</div>
								</div>

								<button className="ant-btn ant-btn-primary settingsButton" onClick={handleUpdateEmail}>
									Save email settings
								</button>

							</div>
						</Card>
					</Row>

				</Container>
			</div>
		</>
	);
}
export default Customize